var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'read-more-container column-start', ("read-more-" + _vm.unicId), 
        { 'pointer': !_vm.normalHeight }
    ],on:{"click":_vm.openContentBox}},[_c('span',{class:['break-all', _vm.characteristic]},[_vm._v("\n        "+_vm._s(_vm.text)+"\n        "),(!_vm.normalHeight)?_c('span',{class:[
                'f-13-blue relative pr-6 no-wrap', 
                _vm.open ? 'read-more-open' : 'read-more-close'
            ]},[_vm._v("\n            "+_vm._s(_vm.open ? 'Show less' : 'Read more')+"\n        ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }